import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    clients: {}
  },
  mutations: {
    set_client (state, { id, client }) {
      console.log(client)
      state.clients[id] = client
    },
    delete_client (state, id) {
      delete (state.clients[id])
    }
  },
  actions: {
    SetClient ({ commit }, client) {
      commit('set_client', {
        id: client.id,
        client
      })
    }
  },
  getters: {
    clients: state => state.clients
  },
  modules: {}
})
